import { ContactUsField } from "@lib/shared/types";

export const genericFields: ContactUsField[] = [
    {
        name: "firstName",
        label: "First Name",
        placeholder: "First Name",
        inputType: "text",
        type: "text",
        validation: {
            required: true,
            rules: {
                type: "isEmpty",
            },
        },
        autocomplete: "given-name",
        serverSideValidation: true,
    },
    {
        name: "lastName",
        label: "Last Name",
        placeholder: "Last Name",
        inputType: "text",
        type: "text",
        validation: {
            required: true,
            rules: {
                type: "isEmpty",
            },
        },
        autocomplete: "family-name",
        serverSideValidation: true,
    },
    {
        name: "companyName",
        label: "Company Name",
        placeholder: "Company Name",
        inputType: "text",
        type: "text",
        validation: {
            required: true,
            rules: {
                type: "isEmpty",
            },
        },
        isExtraField: true,
    },
    {
        name: "email",
        label: "Email",
        placeholder: "Email",
        inputType: "text",
        type: "email",
        validation: {
            required: true,
            rules: {
                type: "isEmail",
            },
        },
        autocomplete: "email",
        serverSideValidation: true,
    },
    {
        name: "phone",
        label: "Phone Number",
        placeholder: "Phone Number",
        inputType: "text",
        type: "tel",
        validation: {
            required: true,
            rules: {
                type: "isPhone",
            },
        },
        autocomplete: "tel",
    },
    {
        name: "subject",
        label: "Subject",
        placeholder: "Subject",
        inputType: "text",
        type: "text",
        validation: {
            required: true,
            rules: {
                type: "isEmpty",
                characterCount: {
                    min: 3,
                    max: 255,
                },
            },
        },
    },
    {
        name: "body",
        label: "Description",
        placeholder:
            "Please enter the details of your request. A member of our support staff will get back to you within 24 hours",
        inputType: "textarea",
        type: null,
        rows: 5,
        validation: {
            required: true,
            rules: {
                type: "isEmpty",
                characterCount: {
                    min: 5,
                    max: 255,
                },
            },
        },
    },
    {
        name: "googleReCaptcha",
        label: "",
        placeholder: "",
        inputType: "recaptcha",
        type: null,
        validation: {
            required: true,
        },
    },
];
